// @/services/newsService.js
import api from "@/utils/api.js";

export const NewsService = {
  /**
   * Get news articles with optional pagination
   * @param {Object} params - Query parameters for the request
   * @param {number} params.limit - Number of articles to fetch
   * @param {number} params.start - Starting index for pagination
   * @returns {Promise<Array>} - Array of news articles
   */
  async getNews(
    params = {
      limit: 0,
      start: 0,
    }
  ) {
    const response = await api.get("/news", { params });
    return response;
  },
};
